<template>
    <section class="key-figures">
        <div class="inner">
            <h2 class="h1 title">{{ title }}</h2>
            <div class="key-figures-cards">
                <div v-for="(card, index) in cards" :key="`key-${index}`" class="key-figures-card">
                    <h3 class="h2 figure">{{ card.title }}</h3>
                    <DSCFText
                        v-if="card.text"
                        class="description"
                        :content="card.text"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

defineProps({
    contentType: {
        type: [String, null],
        required: false,
        default: 'key-figures',
    },
    display: {
        type: Object,
        required: false,
        default: () => ({
            component: 'key-figures',
        }),
    },
    internal: {
        type: [String, null],
        required: false,
        default: 'Key Figures',
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    cards: {
        type: Array,
        required: false,
        default: () => [],
    },
});
</script>

<style scoped>
.key-figures {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.key-figures .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.key-figures .title {
  font-size: 3rem;
  font-weight: 900;
}
@media (max-width: 1199px) {
  .key-figures .title {
    font-size: 1.75rem;
    margin: 1rem;
  }
}
.key-figures .key-figures-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin: 2rem auto;
  width: 100%;
}
@media (max-width: 1199px) {
  .key-figures .key-figures-cards {
    gap: 2rem;
    margin: 1rem;
  }
  .key-figures .key-figures-cards .key-figures-card {
    display: grid;
    min-width: calc(90dvw - 2rem);
  }
}
.key-figures .key-figures-cards .key-figures-card {
  max-width: 33.3333%;
  padding-right: 1rem;
}
.key-figures .key-figures-cards .key-figures-card .figure {
  font-size: 3rem;
  font-weight: 300;
}
@media (max-width: 1199px) {
  .key-figures .key-figures-cards .key-figures-card .figure {
    font-size: 2rem;
  }
}
.key-figures .key-figures-cards .key-figures-card .description {
  font-size: 1rem;
  font-weight: 300;
}
</style>
